// React Query hooks for org-scoped supplier CRUD — list, create, update with cache invalidation.

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { suppliersApi } from "../services/api";
import type { CreateSupplierInput, UpdateSupplierInput } from "../types";

export function useSuppliers(search?: string, status?: string) {
  return useQuery({
    queryKey: ["suppliers", search, status],
    queryFn: () => suppliersApi.list({ search, status }),
  });
}

export function useCreateSupplier() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateSupplierInput) => suppliersApi.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
    },
  });
}

export function useUpdateSupplier() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateSupplierInput }) =>
      suppliersApi.update(id, input),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
      queryClient.invalidateQueries({ queryKey: ["supplier", id] });
    },
  });
}
